<script>
  import { stringify } from 'csv-stringify/browser/esm/sync';
  import { Chart } from 'flowbite-svelte';
  import Legend from './Legend.svelte';
  import { formatNumberWithIntl } from './utils';

  export let chartData;
  export let searchParams;
  export let sendReportCsvExportDebugEvent;

  const COLORS = ['#1C64F2', '#16BDCA', '#FDBA8C', '#E74694'];
  const INDICATOR_BGS = [
    'bg-[#1C64F2]',
    'bg-[#16BDCA]',
    'bg-[#FDBA8C]',
    'bg-[#E74694]',
  ];

  const osLabelToDisplayMap = {
    android: 'Android',
    ios: 'iOS',
  };

  $: legend =
    chartData?.legend.map((l) => {
      return {
        ...l,
        os: osLabelToDisplayMap[l.os],
      };
    }) || [];
  $: options = {
    labels: chartData?.labels,
    series: chartData?.series,
    colors: COLORS,
    chart: {
      width: '100%',
      height: 222,
      type: 'pie',
    },
    stroke: {
      colors: ['white'],
      lineCap: '',
    },
    plotOptions: {
      pie: {
        labels: {
          show: true,
        },
        size: '100%',
        dataLabels: {
          offset: -25,
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    yaxis: {
      labels: {
        formatter(value) {
          return formatNumberWithIntl(value);
        },
      },
    },
    xaxis: {
      labels: {
        formatter(value) {
          return formatNumberWithIntl(value);
        },
      },
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
    },
  };

  function handleClickExport() {
    const mappedResults = Object.entries(chartData?.currentJourneysByKey).map(
      (e) => {
        const [key, value] = e;
        return {
          os: key,
          mobile_clicks: value.mobile_journeys,
        };
      },
    );

    mappedResults.sort((a, b) => b.mobile_clicks - a.mobile_clicks);

    const csv = stringify(mappedResults, {
      header: true,
      columns: [{ key: 'os' }, { key: 'mobile_clicks' }],
    });

    sendReportCsvExportDebugEvent('clicks-by-os');

    // Generate a hidden element to trigger file download
    const hiddenElement = window.document.createElement('a');
    hiddenElement.href = `data:text/csv;charset=utf-8,${encodeURI(csv)}`;
    hiddenElement.target = '_blank';
    hiddenElement.download = `clicks_by_os_${$searchParams.startDate}_${$searchParams.endDate}.csv`;
    hiddenElement.click();
  }
</script>

<Chart {options} class="py-6" />
<Legend
  onClickExport={handleClickExport}
  indicatorColors={INDICATOR_BGS}
  {legend}
  key="os"
/>
